import { render, staticRenderFns } from "./payForAnother.vue?vue&type=template&id=72d442ae&scoped=true&"
import script from "./payForAnother.vue?vue&type=script&lang=js&"
export * from "./payForAnother.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d442ae",
  null
  
)

export default component.exports